import { Box, Typography } from "@mui/material";
import { ReactComponent as DocumentIcon } from "../../../common/icons/documentIcon.svg";

type Props = {
  color?: string;
  label: string;
};

const ValidToLabel = ({ color = "inherit", label }: Props) => (
  <Box component="span" display="flex" alignItems="center" gap="18px">
    <DocumentIcon style={{ minWidth: "22px" }} />
    <Typography component="span" sx={{ color: color }}>
      {label}
    </Typography>
  </Box>
);

export default ValidToLabel;
